import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';

@Component({
  selector: 'app-deposit-paynearme',
  templateUrl: './deposit-paynearme.component.html',
  styleUrls: ['./deposit-paynearme.component.scss'],
})
export class DepositPaynearmeComponent extends CashierBase implements OnInit {

  @Input() public navigateBackPage: any;

  
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public bonusCode: string;
  public buttonDisabled: boolean = false;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;

  public depositForm: FormGroup;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
  ){
    super();
    this.labels = new DepositMainModel();
    this.successMessageService.clearMessage();
  }

  ngOnInit(){
    this.buttonDisabled = false;
    this.depositForm = new FormGroup({});
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
  }

  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('paynearme').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.successMessageService.clearMessage();
    this.error = null;
    
    return this.navigator.navigateTo("DepositPaynearmeV2Component", { multipleModals: true }, {bonusCode: this.bonusCode});
  }

  public selectedDepositBonusOffer($event): void{
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

}
